import { TMainPageLayoutV3 } from "../type";
import { mainPageItemNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";


const MNPG067 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG067.rendered: ", props);

    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions);
    
    return (
        <RMDRComponentSanitizer languageVersion={languageVersion} variant="p" valueExpr="value" removeTag />
    )
}

export default MNPG067;
